import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from '../../redux/title/action';
import { StyledContainer } from '../../components/container/styles';
import { RenderForm } from '../../components/forms';
import { useForm } from 'react-hook-form';
import { FORM_CLAIM } from './form';
import { useGetClaimInfo } from './hooks/useGetClaimInfo';
import { Spin } from 'antd';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';
import { useSubmitCutOff } from './hooks/useSubmitCutOff';
import { useGetWarrantyNumberCode } from './hooks/useGetWarrantyNumberCode';

export const ClaimScene = () => {
  const dispatch = useDispatch();
  const { storeName } = useSelector((state) => state?.info);
  const { scanClaim } = useSelector((state) => state?.scan);
  const { searchClaim } = useSelector((state) => state?.search);
  const { searchCode } = useSelector((state) => state?.searchCode);
  const { scanCode } = useSelector((state) => state?.scanCode);
  const { control, getValues, setValue, reset, handleSubmit, watch } = useForm();
  const { mutate: getClaimInfo, isPending: isPendingGetClaimInfo } = useGetClaimInfo({
    reset,
  });
  const { mutate: submitCutOff, isPending: isPendingSubmitCutOff } = useSubmitCutOff({ reset });
  const { mutate: getWarrantyNumberCode, isPending: isPendingGetWarrantyNumberCode } =
    useGetWarrantyNumberCode();
  const { storeId, claimId, isCrossModel, itemCode } = watch();
  const claimCode = searchClaim?.searchClaim || scanClaim?.scanClaim?.text;
  const warrantyNumberCode = searchCode?.searchCode || scanCode?.scanCode?.text;

  const extractFwParam = (url) => {
    if (!url) return '';

    if (url.includes('?fw=')) {
      try {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);
        const fwParam = params.get('fw');
        return fwParam || url;
      } catch (error) {
        return url;
      }
    }
    return url;
  };

  useEffect(() => {
    if (!warrantyNumberCode) {
      return;
    }

    let codeToUse = extractFwParam(warrantyNumberCode);

    if (codeToUse !== warrantyNumberCode) {
      setValue('warrantyNumberCode', codeToUse);
    }

    getWarrantyNumberCode(codeToUse, {
      onSuccess: (data) => {
        setValue('warrantyNumberCode', data?.result?.warranty?.warrantyNumberCode || '-');
      },
    });
  }, [warrantyNumberCode]);

  useEffect(() => {
    dispatch(setTitle(`สาขา ${storeName || '-'}`));
  }, [storeName]);

  useEffect(() => {
    if (claimCode) {
      getClaimInfo({ claimCode });
    }
  }, [claimCode]);

  const onSubmit = () => {
    const payload = {
      claimId: claimId,
      claimCode: claimCode,
      warrantyNumberCode: extractFwParam(warrantyNumberCode),
      storeId: storeId,
      isCrossModel: isCrossModel === 'true',
      itemCode: itemCode,
    };
  
    if (isCrossModel === 'true') {
      payload.itemCode = getValues('itemCode');
    }
  
    submitCutOff(payload);
  };

  return (
    <Spin
      spinning={isPendingGetClaimInfo || isPendingSubmitCutOff || isPendingGetWarrantyNumberCode}
    >
      <StyledContainer>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_CLAIM({ isCrossModel })}
        />
        <ContainerButton center>
          {isPendingSubmitCutOff ? (
            <Spin spinning={isPendingSubmitCutOff} />
          ) : (
            <ButtonTheme useFor="CLAIM_INFO" onClick={handleSubmit(onSubmit)} />
          )}
        </ContainerButton>
      </StyledContainer>
    </Spin>
  );
};
